var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',[_vm._v("Coucou je lance un timeout au bout de "+_vm._s(_vm.timeout)+" avec le message "+_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }